import { useState } from "react";
import { OTPCodeStep } from "./OTPCodeStep";
import { OTPEmailStep } from "./OTPEmailStep";

type PasswordLessLoginProps = {
  hasBackButton?: boolean;
  shouldRefreshOnSuccess?: boolean;
  onCancel: () => void;
};

export const PasswordLessLogin = ({ hasBackButton, shouldRefreshOnSuccess = false, onCancel }: PasswordLessLoginProps) => {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("email");

  const handleCancel = () => {
    setStep("email");
    onCancel();
  };

  return (
    <>
      {step === "email" && (
        <OTPEmailStep
          hasBackButton={hasBackButton}
          onComplete={({ email }) => {
            setStep("code");
            setEmail(email);
          }}
          onCancel={handleCancel}
        />
      )}
      {step === "code" && (
        <OTPCodeStep
          shouldRefreshOnSuccess={shouldRefreshOnSuccess}
          hasBackButton={hasBackButton}
          email={email}
          onComplete={() => {
            //
          }}
          onCancel={handleCancel}
        />
      )}
    </>
  );
};
